export const LibraryRouting = [
  {
    path: "/material/library/list",
    name: "basic-material-library-list",
    meta: { title: "材料库管理" },
    component: () =>
      import(
        /* webpackChunkName: "basic-material-library" */ "@/views/material/library/list2/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/material/library/create",
    name: "basic-material-library-create",
    meta: { title: "新增材料" },
    component: () =>
      import(
        /* webpackChunkName: "basic-material-library" */ "@/views/material/library/form/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/material/library/edit/:id",
    name: "basic-material-library-edit",
    meta: { title: "编辑材料" },
    component: () =>
      import(
        /* webpackChunkName: "basic-material-library" */ "@/views/material/library/form/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/material/library/detail/:id",
    name: "basic-material-library-detail",
    meta: { title: "材料详情" },
    component: () =>
      import(
        /* webpackChunkName: "basic-material-library" */ "@/views/material/library/form-detail/index.vue"
      ),
  },
];
